import { createFileRoute } from "@tanstack/react-router";
import { AnomalyInbox } from "./workspaces.$workspaceId.anomalies";

export const Route = createFileRoute("/_authenticated/anomalies")({
  component: () => (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Anomaly Inbox</h1>
        <p className="text-sm text-muted-foreground">Issues across every workspace, in one place.</p>
      </div>
      <AnomalyInbox />
    </div>
  ),
});
